import { Icon, IconButton, Tooltip } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import DenseAppBar from "../../components/AppBar";
import Input from "../../components/Input";
import MetricsCard from "../../components/MetricsCard";
import AlertModal from "../../components/Modal";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import StatusAlert from "../../components/StatusAlert";
import UtilityFilters from "../../components/utilityFilter";
import { getCurrency } from "../../helpers/Functions";
import { Reducers } from "../../Interfaces/Interfaces";
import {
  assignMultipleTerminal, assignMultipleTerminalsToAggregator, assignTerminal,
  getAggregatorAgents, getPosAggregatorTransactionsForTab, getSuperAggregatorAggregators, getTerminals, placeTerminalOnPnd, retrieveTerminal, retrieveTerminalAggregatorAction, toggleTerminalState
} from "../../redux/actions/POSAction";
import { getPOSDashboard } from "../../redux/actions/userActions";
import PrimaryTheme from "../../Themes/Primary";

import Select from 'react-select';


export default function POS() {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const { enqueueSnackbar } = useSnackbar();
  const alert = useSelector((state: Reducers) => state.alert);
  const agents = useSelector((state: Reducers) => state.agents);
  const dashboard = useSelector((state: Reducers) => state.dashboard);
  const terminals = useSelector((state: Reducers) => state.terminals);
  const userType = useSelector((state: Reducers) => state.userType);
  const loader = useSelector((state: Reducers) => state.internalLoader);
  const posTransactions = useSelector(
    (state: any) => state.posAggregatorTransactionReducer
  );

  const superAggregatorAggregator = useSelector(
    (state: any) => state.superAggregatorAggregator
  );

  const [searchState, setSearchState] = React.useState("");
  const [filterAgentName, setfilterAgentName] = React.useState("");
  const [filterAggregatorName, setfilterAggregatorName] = React.useState("");

  const [searchText, setSearchText] = React.useState("");
  const [agentPhoneNumber, setAgentPhoneNumber] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [pin, setPin] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [terminal, setTerminal]: any = React.useState("");
  const [comment, setComment]: any = React.useState("");
  const [title, setTitle]: any = React.useState("");
  const [item, setItem]: any = React.useState("");
  const [subtitle, setSubtitle]: any = React.useState("");
  const [agent, setAgent]: any = React.useState("");
  const [agentId, setAgentId]: any = React.useState("");
  const [type, setType] = React.useState(0); // retrieve = 1, start = 2, stop = 4, assign = 3, multiple=5
  const [submitted, setSubmitted] = React.useState(false);
  const [posState, setPosState]: any = React.useState(0);
  const [targetStatus, setTargetStatus]: any = React.useState("");
  const [groupTerminal, setgroupTerminal] = useState(false);
  const [multipleTerminal, setmultipleTerminal]: any = useState([]);
  const [transPeriod, setTransPeriod] = React.useState(1);
  const [transLoading, setTransLoading] = React.useState(false);
  const [agentDropdownName, setagentDropdownName] = React.useState("");
  var d = new Date();
  d.setDate(d.getDate() - 2);
  const [rangeState, setrangeState]: any = React.useState([
    {
      startDate: d,
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [TerminalPhoneNumber, setTerminalPhoneNumber] = React.useState("");
  const [TerminalIdState, setTerminalIdState] = React.useState("");
  const [PosTransferSearchSatate, setPosTransferSearchSatate] =
    React.useState("");
  const [RefrenceValue, setRefrenceValue] = React.useState("");
  const [canAssignPos, setCanAssignPos] = React.useState(
    user.permission && user.permission.canAssignPos
  );
  const [SwitchTab, setSwitchTab] = React.useState(false);
  const [SingleTab, setSingleTab] = React.useState(1);
  const [AggregatorNameDropdown, setAggregatorNameDropdown] =
    React.useState("");
  let list = terminals && terminals.items;
  let listTransactions = posTransactions && posTransactions.items;

  let agentList = agents && agents.result;
  let AggregatorList = superAggregatorAggregator && superAggregatorAggregator;
  // let selectedItems: any[] = [];

  const [multipleTerminalLoader, setmultipleTerminalLoader] = useState(false);
  const [Index, setIndex]: any = React.useState("");
  let filter: any = {};
  let filterTransaction: any = {
    dateCreatedFrom: d,
    dateCreatedTo: new Date(),
  };
  const dashboardFilter: any = {
    id: user.id,
    whereCondition: JSON.stringify(filterTransaction),
  };
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  let checkItems: any[] = [];

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    // dashboardFilter.whereCondition
    dispatch(getPOSDashboard(user.id));
    dispatch(getTerminals(paginationConfig));
  };

  const goBack = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    history.push("/dashboard");
  };

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    setPosState(0);
    setTargetStatus("");

    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getPOSDashboard(user.id));
    dispatch(getTerminals(paginationConfig));
  };

  const handleState = (val: number, item: any) => {
    setmultipleTerminal([]);
    setType(val);
    setItem(item);
    setAgent(item.agentName);
    setAgentId(item.id);
    setTerminal(item.terminalId);

    setTitle("STOP/START POS TERMINAL");
    setSubtitle("Stop/Start a POS Terminal with an Agent account");

    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    setLoading(true);
    dispatch(toggleTerminalState(item.id));
  };

  const handleRetrieval = (e: any) => {
    e.preventDefault();

    const data = {
      posTerminalId: item.id,
      comment,
      transactionPin: pin,
    };

    let aggregatorR = {
      posTerminalId: item.id,
      comment,
      transactionPin: pin,
    };

    setLoading(true);

    switch (SingleTab) {
      case 1:
        dispatch(retrieveTerminal(data));
        break;
      case 2:
        dispatch(retrieveTerminalAggregatorAction(aggregatorR));
        break;
      default:
        dispatch(retrieveTerminal(data));
        break;
    }
  };

  React.useEffect(() => {
    dispatch(getAggregatorAgents(user.id));
    dispatch(getSuperAggregatorAggregators());

    dispatch(getPosAggregatorTransactionsForTab(paginationConfig));
  }, [dispatch]);
  const handleMapping = (e: any) => {
    e.preventDefault();
    if (agentId === "0" || agentId === null) {
      enqueueSnackbar("Select an agent or aggregator", { variant: "error" });
    } else {
      const data = {
        agentId: agentId.value,
        posTerminalId: item.id,
        transactionPin: pin,
      };
      let aggregatorData2 = {
        aggregatorId: agentId.value,
        transactionPin: pin,
        terminalIds: [item.id],
      };
      // console.log(data);
      // console.log(aggregatorData2);
      

      setLoading(true);
      switch (SingleTab) {
        case 1:
          dispatch(assignTerminal(data));
          break;
        case 2:
          dispatch(assignMultipleTerminalsToAggregator(aggregatorData2));
          break;
        default:
          dispatch(assignTerminal(data));
          break;
      }
    }
  };

  const handleMappingSuperAggregator = (e: any) => {
    e.preventDefault();
    if (agentId === "0") {
      enqueueSnackbar("Select an agent or aggregator", { variant: "error" });
    } else {
      const data = {
        aggregatorId: agentId,
        terminalIds: [item.id],
        transactionPin: pin,
      };
      setLoading(true);

      dispatch(assignMultipleTerminalsToAggregator(data));
    }
  };

  const handlePND = (e: any) => {
    e.preventDefault();

    const data = {
      agentId,
      posTerminalId: item.id,
      transactionPin: pin,
      comment,
    };

    setLoading(true);
    // console.log({ data });
    dispatch(placeTerminalOnPnd(data));
  };

  const callTerminals = () => {
    paginationConfig.whereCondition = JSON.stringify(filter);
    dispatch(getTerminals(paginationConfig));
  };

  const clearModalFields = () => {
    // setType(0);
    setLoading(false);
    // setAgent("");
    setAgentId("")
    setTerminal("");
    setComment("")
    setPin("")
  };

  const openModal = (type: number, item: any) => {
    setType(type);
    setItem(item);
    
    setgroupTerminal(false);
    setmultipleTerminal([]);
    setAgentId(item.assignedAgentId);
    setAgent(item.agentName);
    setSingleTab(1);
    setmultipleTerminalLoader(false);
    clearModalFields()
    setTerminal(item.terminalId);

    switch (type) {
      case 1:
        setTitle("RETRIEVE POS TERMINAL");
        setSubtitle("Retrieve a POS Terminal from an Agent account");
        break;
      case 2:
        setTitle("STOP/START POS TERMINAL");
        setSubtitle("Stop/Start a POS Terminal with an Agent account");
        break;
      case 3:
        setTitle("ASSIGN POS TERMINAL");
        setSubtitle("Map a POS Terminal to an Agent account");
        break;
      case 6:
        setTitle("POST-NO-DEBIT");
        setSubtitle("This list shows active terminals assigned to this agent.");
        break;
      case 10:
        setTitle("Assign Terminal To Aggregator");
        setSubtitle("");
        break;
      default:
        setTitle("RETRIEVE POS TERMINAL");
        setSubtitle("Retrieve a POS Terminal from an Agent account");
    }

    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };
  const handleSelect = (date: any) => {
    setrangeState([date.selection]);

    filterTransaction.dateCreatedFrom = date.selection.startDate;
    filterTransaction.dateCreatedTo = date.selection.endDate;

    setTransLoading(true);
  };
  React.useEffect(() => {
    // dispatch(getTransactionDashboard(dashboardFilter));
  }, [rangeState]);

  const handlePosTerminalSearch = (e: string) => {
    // filter.searchText = e;
    setSearchState(e);
    callTerminals();
  };

  const handleAssignedAgentPhoneSearch = (e: string) => {
    filter.agentPhoneNumber = e;

    paginationConfig.whereCondition = JSON.stringify(filter);
    //setSearchState(e);
    callTerminals();
  };

  const agentArrayList = agentList?.map((item: any, index: number) => {
    return {value: item.id, label: item.name}
    
  })

  const handlePhoneSearch = (e: string) => {
    filter.phoneNumber = e;
    paginationConfig.whereCondition = JSON.stringify(filter);
    callTerminals();
  };
  const closeModal = () => {
    setType(0);
    setLoading(false);
    setType(0);
    setAgent("");
    setTerminal("");
    setComment("")
    setPin("")
    dispatch({ type: "ALERT_MODAL", payload: false });
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    setPageSize(value.props.value);
    paginationConfig.pageSize = value.props.value;
    callTerminals();
  };

  // filters
  React.useEffect(() => {
    if (posState !== 0) {
      filter.locationId = posState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });

      callTerminals();
    }

    if (searchState.length > 3) {
      filter.searchText = searchState;

      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });

      callTerminals();
    }

    if (targetStatus !== "") {
      filter.targetStatus = targetStatus;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });
      callTerminals();
    } else {
      callTerminals();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posState, dispatch, targetStatus, searchState]);

  React.useEffect(() => {
    console.log(filterAgentName);
    if (filterAgentName !== "") {
      filter.assignedAgentId = filterAgentName;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });
      callTerminals();
    } else {
      callTerminals();
    }
  }, [filterAgentName]);

  React.useEffect(() => {
    if (filterAggregatorName !== "") {
      filter.assignedAggregatorId = filterAggregatorName;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });
      callTerminals();
    } else {
      callTerminals();
    }
  }, [filterAggregatorName]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    callTerminals();

    return () => {
      dispatch({
        type: "TERMINALS",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch(getPOSDashboard(user.id));

    return () => {
      // dispatch({
      //   type: 'DASHBOARD',
      //   payload: {}
      // });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "ALERT",
          payload: {},
        });

        setSubmitted(false);
        setLoading(false);
        setmultipleTerminalLoader(false);
      } else {
        setPin("");
        setComment("");

        if (alert.message === "Successful") {
          setSwitchTab(false);
          setSubmitted(true);
          setmultipleTerminal([]);
          setgroupTerminal(false);
          setmultipleTerminalLoader(false);
          callTerminals();
          closeModal();
          setSingleTab(1);
          switch (type) {
            case 1:
              setTitle("Terminal Retrieved Successfully");
              setSubtitle(
                "The POS Terminal has been retrieved from your agent. Proceed to Map the Terminal to another agent instantly. If the Terminal needs repairs, kindly contact your sales rep Or send the terminal across to our main office"
              );
              break;

            case 2:
              setTitle("Terminal Stopped Successfully");
              setSubtitle(
                "The POS Terminal has been stopped with your agent. If the Terminal needs repairs, kindly contact your sales rep Or send the terminal across to our main office"
              );
              break;

            case 4:
              setTitle("Terminal Started Successfully");
              setSubtitle(
                "The POS Terminal has been started with your agent. If the Terminal needs repairs, kindly contact your sales rep Or send the terminal across to our main office"
              );
              break;

            case 3:
              setTitle("Terminal Mapped Successfully");
              setSubtitle(
                "The POS Terminal has been mapped to your agent. Kindly inform your agent to start the POS Terminal on their App. Your agent would receive a guide on how to start their POS Terminal Once the POS Terminal is started you can proceed to pull agent details."
              );
              break;
            case 5:
              setTitle("Terminal Mapped Successfully");
              setSubtitle(
                "The POS Terminal has been mapped to your agent. Kindly inform your agent to start the POS Terminal on their App. Your agent would receive a guide on how to start their POS Terminal Once the POS Terminal is started you can proceed to pull agent details."
              );

              break;
            case 6:
              setTitle("Terminal POST-NO-DEBIT Successful");
              setSubtitle("Terminal POST-NO-DEBIT Successful.");
              break;
            case 10:
              setTitle("Terminal Mapped Successfully");
              setSubtitle(
                "The POS Terminal has been mapped to the aggregator. Kindly inform your aggregator that the terminals are now available for them to assign to their agents."
              );

              break;

            case 11:
              setTitle("Terminal Mapped Successfully");
              setSubtitle(
                "The POS Terminal has been mapped to the aggregator. Kindly inform your aggregator that the terminals are now available for them to assign to their agents."
              );

              break;
            default:
              setTitle("RETRIEVE POS TERMINAL");
              setSubtitle("Retrieve a POS Terminal from an Agent account");
          }

          dispatch({
            type: "STATUS_ALERT",
            payload: true,
          });
        }

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert]);

  const handleSingleTabClicked = (tabSelected: any) => {
    setSingleTab(tabSelected);
  };
  React.useEffect(() => {
    switch (SingleTab) {
      case 1:
        setAgentId(item.assignedAgentId);
        setAgent(item.agentName);
        break;
      case 2:
        setAgentId(item.assignedAggregatorId);
        setAgent(item.aggregatorName);
        break;
      default:
        setAgentId(item.assignedAggregatorId);
        setAgent(item.agentName);
    }
  }, [SingleTab]);

  const [tofalse, settofalse]: any = useState({
    id: "",
  });
  React.useEffect(() => {
    if (multipleTerminal.length === 0) {
      setgroupTerminal(false);
    }
  }, [multipleTerminal]);
  const handleSelectTerminal = (check: any, terminalValue: any, index: any) => {
    let data = {
      id: terminalValue.id,
      checked: true,
      terminalId: terminalValue.terminalId,
    };
    setIndex(index);

    if (check) {
      // checkItems.push(data);

      setmultipleTerminal([...multipleTerminal, data]);
    } else {
      const getStateFilter = multipleTerminal.filter(
        (item: any) => item.terminalId !== data.terminalId
      );
      setmultipleTerminal([...getStateFilter]);
    }
  };

  // const handleChangeTransaction = (value: any) => {
  //   setTransLoading(true);
  //   setTransPeriod(value);
  // };
  // React.useEffect(() => {

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [dispatch, rangeState]);

  const handleView = () => {
    setType(5);
    setgroupTerminal(true);

    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };

  const handleDeleteSingleTerminal = (terminalId: any) => {
    const findIfIdExist = multipleTerminal.filter(
      (terminal: any) => terminal.terminalId !== terminalId.terminalId
    );
    setmultipleTerminal(findIfIdExist);

    if (multipleTerminal.length === 1) {
      dispatch({
        type: "ALERT_MODAL",
        payload: false,
      });
    }
  };

  React.useEffect(() => {
    if (!loader) {
      setTransLoading(false);
    }
  }, [loader]);

  const handleMutipleAssignmentBtn = () => {
    if (agentId === "0") {
      enqueueSnackbar("Select an agent or aggregator", { variant: "error" });
    } else {
      let data = {
        agentId: agentId,
        transactionPin: pin,
        assignedTerminals: multipleTerminal,
      };
      let aggregatorData = {
        aggregatorId: agentId,
        transactionPin: pin,
        terminalIds: multipleTerminal.map((list: any) => list.id),
      };

      setmultipleTerminalLoader(true);

      switch (SwitchTab) {
        case false:
          dispatch(assignMultipleTerminal(data));
          break;
        case true:
          setType(11);
          dispatch(assignMultipleTerminalsToAggregator(aggregatorData));
          break;
        default:
          return dispatch(assignMultipleTerminal(data));
      }
    }
  };
  const getColor = (status: any) => {
    switch (status) {
      case "Active":
        return "btn-success";
        break;
      case "Inactive":
        return "btn-warning";
        break;
      default:
        return "btn-danger";
        break;
    }
  };
  const handleAgentDropdown = (e: any) => {
    setfilterAgentName(e.value);
    setagentDropdownName(e.label);
  };
  const handleAggregatorDropdown = (e: any) => {
    setfilterAggregatorName(e.value);
    setAggregatorNameDropdown(e.label);
  };
  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          // height: '100vh',
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            height: "100vh",
            position: "relative",

            // zIndex: 1000,
          }}
        >
          <h1
            className="mb-5 pos-title"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle,
              background: "inherit",
            }}
          >
            POS Manager
            <div style={{ position: "relative", left: "51%", width: "100%" }}>
              {/* <DateFilter
                ranges={rangeState}
                handleSelect={(item: any) => handleSelect(item)}
                labelPosition="left"
              /> */}
            </div>
          </h1>

          {/* cards  */}
          <div className="row mb-5">
            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="first"
                title="TERMINAL REQUEST"
                value={
                  dashboard.terminalRequests
                    ? dashboard.terminalRequests.toLocaleString()
                    : "0"
                }
                hasButton
                buttonTitle="Recommend POS"
                buttonColor={PrimaryTheme.primary}
                buttonClick={() => history.push(`/pos/recommend`)}
              />
            </div>

            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="second"
                value={
                  dashboard.numberOfTerminals
                    ? dashboard.numberOfTerminals.toLocaleString()
                    : "0"
                }
                buttonColor={PrimaryTheme.primary}
                hasButton
                buttonTitle="Assigned POS"
                title="POS Terminals"
                buttonClick={() => history.push(`/pos/assigned`)}
              />
            </div>

            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="third"
                value={
                  dashboard.numberOfTransactions
                    ? dashboard.numberOfTransactions.toLocaleString()
                    : "0"
                }
                hasButton
                buttonColor={PrimaryTheme.primary}
                buttonTitle="View POS Transactions"
                buttonClick={() => history.push(`/pos/transactions`)}
                title="Total Transactions"
                isLoading={transLoading}
                // onMenuChange={(e: any) =>
                //   handleChangeTransaction(e.target.value)
                // }
                // disabled={userType === '5' ? false : true}
              />
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-12 display-assign-on-small">
              {" "}
              {multipleTerminal.length ? (
                <span
                  style={{
                    cursor: "pointer",
                    fontSize: PrimaryTheme.fontSizes?.small,
                    marginLeft: "20px",
                  }}
                  onClick={handleView}
                >
                  <Tooltip title="Assign">
                    <IconButton size="small">
                      <Icon
                        style={{
                          color: PrimaryTheme.success,
                        }}
                      >
                        how_to_reg
                      </Icon>
                    </IconButton>
                  </Tooltip>
                  Assign
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12  mb-3" style={{ paddingBottom: "100px" }}>
              <Tabs>
                {/* <TabList>
                  <Tab>POS Terminals</Tab>
                  <Tab>POS Transactions</Tab>
                </TabList> */}

                <TabPanel>
                  <div style={{ marginBottom: "20px" }}>
                    <div className="row" style={{ marginBottom: "20px" }}>
                      {user.isSuperAggregator ? (
                        <div className="col-md-5 col-12">
                          <UtilityFilters
                            listOfAgents={agentList}
                            listOfAggregator={AggregatorList}
                            aggregatorStateChange={(e: any) =>
                              handleAggregatorDropdown(e)
                            }
                            hasAggregator
                            aggregatorState={AggregatorNameDropdown}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="col-md-4 col-12">
                        <UtilityFilters
                          listOfAgents={agentList}
                          listOfAggregator={AggregatorList}
                          agentStateChange={(e: any) => handleAgentDropdown(e)}
                          agentState={agentDropdownName}
                          hasAgent
                        />
                      </div>
                      <div className="col-md-3 col-12">
                        <UtilityFilters
                          listOfAgents={agentList}
                          listOfAggregator={AggregatorList}
                          posTarget={targetStatus}
                          posTargetChange={(e: any) =>
                            setTargetStatus(e.target.value)
                          }
                          hasTarget
                        />
                      </div>
                      {!user.isSuperAggregator ? (
                        <div className="col-md-5 col-12">
                          <UtilityFilters
                            onClear={handleClear}
                            handleSearch={(e: any) =>
                              handlePosTerminalSearch(e.target.value)
                            }
                            searchState={searchState}
                            listOfAgents={agentList}
                            listOfAggregator={AggregatorList}
                            hasSearch
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="row">
                      <div className="col-md col-12">
                        {multipleTerminal.length ? (
                          <span
                            style={{
                              cursor: "pointer",
                              fontSize: PrimaryTheme.fontSizes?.small,

                              border: "3px dashed #000000",
                              padding: "10px 20px 10px 20px",
                            }}
                            onClick={handleView}
                          >
                            <Tooltip title="Assign">
                              <IconButton size="small">
                                <Icon
                                  style={{
                                    color: PrimaryTheme.success,
                                  }}
                                >
                                  how_to_reg
                                </Icon>
                              </IconButton>
                            </Tooltip>
                            Assign
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-md-5 col-12">
                        {user.isSuperAggregator ? (
                          <UtilityFilters
                            onClear={handleClear}
                            handleSearch={(e: any) =>
                              handlePosTerminalSearch(e.target.value)
                            }
                            searchState={searchState}
                            listOfAgents={agentList}
                            listOfAggregator={AggregatorList}
                            hasSearch
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  {list ? (
                    <React.Fragment>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead className="thead-primary">
                            <tr className="text-center">
                              <th scope="col">S/N</th>
                              <th scope="col">Terminal Serial</th>
                              <th scope="col">Terminal ID</th>
                              {user.isSuperAggregator ? (
                                <th scope="col">Aggregator</th>
                              ) : (
                                ""
                              )}

                              <th scope="col">Agent Name</th>
                              <th scope="col">TOTAL PERF (%)</th>

                              <th scope="col">Status</th>
                              <th scope="col">Total Amount</th>
                              <th scope="col">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {list.length !== 0 &&
                              list?.map((item: any, index: number) => (
                                <tr
                                  title="Click to view"
                                  key={index}
                                  className="pointer text-center"
                                >
                                  <th scope="row">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="flexCheckChecked"
                                      onChange={(evt) =>
                                        handleSelectTerminal(
                                          evt.target.checked,
                                          item,
                                          index
                                        )
                                      }
                                      checked={multipleTerminal.find(
                                        (terminal: any) =>
                                          terminal.terminalId ===
                                          item.terminalId
                                            ? terminal.checked
                                            : false
                                      )}
                                    />

                                    {getIndexSeed(index)}
                                  </th>
                                   <td
                                    onClick={() =>
                                      history.push(`/pos/details/${item.id}`)
                                    }
                                  >
                                    {item.serialNumber ? item.serialNumber : "-"}
                                  </td>
                                  <td
                                    onClick={() =>
                                      history.push(`/pos/details/${item.id}`)
                                    }
                                  >
                                    {item.terminalId ? item.terminalId : "-"}
                                  </td>
                                  {user.isSuperAggregator ? (
                                    <td
                                      onClick={() =>
                                        history.push(`/pos/details/${item.id}`)
                                      }
                                    >
                                      {item.aggregatorName}
                                      <br />
                                      <code>{item.aggregatorPhoneNumber}</code>
                                    </td>
                                  ) : (
                                    ""
                                  )}
                                  <td
                                    onClick={() =>
                                      history.push(`/pos/details/${item.id}`)
                                    }
                                  >
                                    {item.agentName}
                                  </td>
                                  <td
                                    onClick={() =>
                                      history.push(`/pos/details/${item.id}`)
                                    }
                                  >
                                    {item.percentagePerformance
                                      ? item.percentagePerformance + "%"
                                      : 0 + "%"}
                                  </td>

                                  <td
                                    onClick={() =>
                                      history.push(`/pos/details/${item.id}`)
                                    }
                                  >
                                    <button
                                      className={getColor(item.terminalStatus)}
                                      style={{
                                        paddingTop: "3px",
                                        paddingBottom: "3px",
                                        paddingLeft: "20px",
                                        paddingRight: "20px",
                                        border: "none",
                                        borderRadius: "10px",
                                        color: "white",
                                      }}
                                    >
                                      {item.terminalStatus}
                                    </button>
                                  </td>
                                  <td
                                    onClick={() =>
                                      history.push(`/pos/details/${item.id}`)
                                    }
                                  >
                                    {item.transactionVolume
                                      ? getCurrency(item.transactionVolume)
                                      : getCurrency("0")}
                                  </td>

                                  <td
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {item.assignedToAgent ? (
                                      <Tooltip title="Retrieve">
                                        <IconButton
                                          disabled={
                                            userType === "5" || canAssignPos
                                              ? false
                                              : true
                                          }
                                          size="small"
                                          onClick={() => openModal(1, item)}
                                        >
                                          <Icon
                                            style={{
                                              color: PrimaryTheme.light,
                                            }}
                                          >
                                            person_add_disabled
                                          </Icon>
                                        </IconButton>
                                      </Tooltip>
                                    ) : (
                                      <IconButton size="small" disabled>
                                        <Icon
                                          style={{
                                            color: PrimaryTheme.light,
                                          }}
                                        >
                                          person_add_disabled
                                        </Icon>
                                      </IconButton>
                                    )}

                                    {item.state === 1 ? (
                                      <Tooltip title="Start terminal">
                                        <IconButton
                                          disabled={
                                            userType === "5" || canAssignPos
                                              ? false
                                              : true
                                          }
                                          size="small"
                                          style={{
                                            marginRight: 5,
                                            marginLeft: 5,
                                          }}
                                          onClick={() => handleState(4, item)}
                                        >
                                          <Icon
                                            style={{
                                              color: PrimaryTheme.success,
                                            }}
                                          >
                                            play_arrow
                                          </Icon>
                                        </IconButton>
                                      </Tooltip>
                                    ) : (
                                      <Tooltip title="Stop terminal">
                                        <IconButton
                                          disabled={
                                            userType === "5" || canAssignPos
                                              ? false
                                              : true
                                          }
                                          size="small"
                                          style={{
                                            marginRight: 5,
                                            marginLeft: 5,
                                          }}
                                          onClick={() => handleState(2, item)}
                                        >
                                          <Icon
                                            style={{
                                              color: PrimaryTheme.light,
                                            }}
                                          >
                                            stop
                                          </Icon>
                                        </IconButton>
                                      </Tooltip>
                                    )}

                                    {item.assignedToAgent ? (
                                      <IconButton size="small" disabled>
                                        <Icon
                                          style={{
                                            color: PrimaryTheme.light,
                                          }}
                                        >
                                          how_to_reg
                                        </Icon>
                                      </IconButton>
                                    ) : (
                                      <Tooltip title="Assign">
                                        <IconButton
                                          disabled={
                                            userType === "5" || canAssignPos
                                              ? false
                                              : true
                                          }
                                          size="small"
                                          onClick={() => openModal(3, item)}
                                        >
                                          <Icon
                                            style={{
                                              color: PrimaryTheme.success,
                                            }}
                                          >
                                            how_to_reg
                                          </Icon>
                                        </IconButton>
                                      </Tooltip>
                                    )}

                                    {/* {user.isSuperAggregator ? (
                                      item.assignedAggregator ? (
                                        <IconButton size="small" disabled>
                                          <Icon
                                            style={{
                                              color: PrimaryTheme.light,
                                            }}
                                          >
                                            how_to_reg
                                          </Icon>
                                        </IconButton>
                                      ) : (
                                        <Tooltip title="Assign Aggregator">
                                          <IconButton
                                            size="small"
                                            onClick={() => openModal(10, item)}
                                          >
                                            <Icon
                                              style={{
                                                color: PrimaryTheme.success,
                                              }}
                                            >
                                              how_to_reg
                                            </Icon>
                                          </IconButton>
                                        </Tooltip>
                                      )
                                    ) : (
                                      ""
                                    )} */}
                                    {item.assignedAgentId > 0 &&
                                    !item.hasPnd ? (
                                      <Tooltip title="Agent account not on PND">
                                        <IconButton
                                          size="small"
                                          onClick={() => openModal(6, item)}
                                        >
                                          <Icon
                                            style={{
                                              color: PrimaryTheme.light,
                                            }}
                                          >
                                            remove_moderator
                                          </Icon>
                                        </IconButton>
                                      </Tooltip>
                                    ) : (
                                      item.assignedAgentId > 0 && (
                                        <Tooltip title="Agent account on PND">
                                          <IconButton
                                            size="small"
                                            onClick={() => openModal(6, item)}
                                          >
                                            <Icon
                                              style={{
                                                color: PrimaryTheme.success,
                                              }}
                                            >
                                              shield
                                            </Icon>
                                          </IconButton>
                                        </Tooltip>
                                      )
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {list.length === 0 && (
                        <React.Fragment>
                          <p className="text-center mt-3 text-dark w-100">
                            No result
                          </p>
                        </React.Fragment>
                      )}

                      <div className="col-md-12 p-0">
                        {terminals.total > pageSize && (
                          <PaginationControlled
                            onPageSizeChange={handlePageSizeChange}
                            onChange={handleChange}
                            page={page}
                            total={terminals.total && terminals.total}
                            pageSize={pageSize}
                          />
                        )}
                      </div>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                    </React.Fragment>
                  )}
                </TabPanel>
                {/* Transaction Table Tab */}
                <TabPanel></TabPanel>
              </Tabs>
            </div>
          </div>
        </div>

        <AlertModal showClose>
          <div>
            {groupTerminal ? (
              <div className="col-md-12 pl-5 pr-5 pb-5 text-center">
                <div className="col-md-12">
                  <span
                    className="badge-pill p-3 d-block col-7 ml-auto mr-auto assign-title"
                    style={{
                      background: PrimaryTheme.warn,
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                    }}
                  >
                    ASSIGN POS TERMINAL
                  </span>
                  {user.isSuperAggregator ? (
                    <div style={{ width: "100%", marginTop: "20px" }}>
                      <span
                        style={{
                          padding: "10px 35px 10px 35px",
                          borderLeft: `1px solid ${PrimaryTheme.primary}`,
                          borderTop: `1px solid ${PrimaryTheme.primary}`,
                          borderBottom: `1px solid ${PrimaryTheme.primary}`,
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                          background: SwitchTab ? "" : PrimaryTheme.primary,
                          color: SwitchTab ? "" : "white",
                          cursor: "pointer",
                        }}
                        onClick={() => setSwitchTab(false)}
                      >
                        Agent
                      </span>
                      <span
                        style={{
                          padding: "10px 35px 10px 35px",
                          borderRight: `1px solid ${PrimaryTheme.primary}`,
                          borderTop: `1px solid ${PrimaryTheme.primary}`,
                          borderBottom: `1px solid ${PrimaryTheme.primary}`,
                          borderTopRightRadius: "20px",
                          borderBottomRightRadius: "20px",
                          background: !SwitchTab ? "" : PrimaryTheme.primary,
                          color: !SwitchTab ? "" : "white",
                          cursor: "pointer",
                        }}
                        onClick={() => setSwitchTab(true)}
                      >
                        Aggregator
                      </span>
                    </div>
                  ) : (
                    ""
                  )}

                  <p
                    className="mt-3 mb-5"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RegularFont,
                      fontSize: 14,
                      color: PrimaryTheme.light,
                    }}
                  >
                    {user.isSuperAggregator
                      ? SwitchTab
                        ? "ASSIGN a POS Terminal from an Aggregator account"
                        : "ASSIGN a POS Terminal from an Agent account"
                      : "ASSIGN a POS Terminal from an Agent account"}
                  </p>
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="terminal"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Terminal IDS
                    </label>
                    <div
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "500px",
                        overflowX: "scroll",
                      }}
                    >
                      <ul style={{ display: "flex", listStyle: "none" }}>
                        {multipleTerminal.map((terminalLists: any) => (
                          <li
                            key={terminalLists.terminalId}
                            style={{
                              marginRight: "5px",
                              background: "silver",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                              borderRadius: "26px",
                              fontSize: PrimaryTheme.fontSizes?.normal,
                            }}
                          >
                            {terminalLists.terminalId}
                            <span
                              style={{
                                marginLeft: "5px",
                                fontSize: PrimaryTheme.fontSizes?.normal,
                                fontWeight: 700,
                                color: "white",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleDeleteSingleTerminal(terminalLists)
                              }
                            >
                              X
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="form-group text-left">
                    <label
                      htmlFor="state"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {user.isSuperAggregator
                        ? SwitchTab
                          ? "Select Aggregator"
                          : "Select Agent"
                        : "Select Agent"}
                    </label>
                    <select
                      className="custom-select"
                      value={agentId}
                      onChange={(e) => setAgentId(e.target.value)}
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        backgroundColor: "#F4F7FC",
                        borderRadius: 25,
                        border: "1px solid white",
                        padding: 15,
                        height: "auto",
                        boxShadow: "none",
                      }}
                    >
                      <option value="0">
                        {SwitchTab ? "Select Aggregator" : "Select Agent"}
                      </option>
                      {user.isSuperAggregator
                        ? !SwitchTab
                          ? agentList &&
                            agentList.map((item: any, index: number) => (
                              <option key={index} value={item.id}>
                                {item.name}
                              </option>
                            ))
                          : AggregatorList &&
                            AggregatorList.map((item: any, index: number) => (
                              <option key={index} value={item.id}>
                                {item.name}
                              </option>
                            ))
                        : agentList &&
                          agentList.map((item: any, index: number) => (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                    </select>
                  </div>
                  <div className="row m-0 justify-content-center align-items-center">
                    <div className="col-md-12 text-left">
                      <label
                        htmlFor="agent"
                        style={{
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.dark,
                        }}
                      >
                        ENTER PIN
                      </label>
                    </div>
                    <OtpInput
                      value={pin}
                      onChange={(e: any) => setPin(e)}
                      numInputs={4}
                      isInputNum
                      shouldAutoFocus
                      inputStyle={{
                        width: "45px",
                        height: "45px",
                        fontSize: "24px",
                        padding: 0,
                        textAlign: "center",
                        borderRadius: 10,
                        border: "1px solid",
                        borderColor: PrimaryTheme.primary,
                      }}
                      isInputSecure
                      separator={<span className="mr-3"> </span>}
                    />
                  </div>
                  <div
                    className="form-group mt-5 mb-0"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    {agentId === "" || pin === "" ? (
                      <div
                        style={{
                          paddingTop: "10px",
                          paddingBottom: "10px",
                          borderRadius: "26px",
                          background: PrimaryTheme.primary,
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.white,
                        }}
                        className="text-bold border-0 col-md-6"
                      >
                        Confirm Mapping
                      </div>
                    ) : (
                      <button
                        onClick={handleMutipleAssignmentBtn}
                        disabled={agentId === "" || pin === "" ? true : false}
                        style={{
                          paddingTop: "10px",
                          paddingBottom: "10px",
                          borderRadius: "26px",
                          background: PrimaryTheme.primary,
                          fontFamily: PrimaryTheme.fonts?.MediumFont,
                          color: PrimaryTheme.white,
                        }}
                        className="text-bold border-0 col-md-6"
                      >
                        {multipleTerminalLoader
                          ? "Please wait..."
                          : "Confirm Mapping"}
                      </button>
                    )}
                  </div>
                </div>
                {/* end of mutiple pos map to agent */}
              </div>
            ) : (
              <div className="col-md-12 pl-5 pr-5 pb-5 text-center">
                <div className="col-md-12">
                  <span
                    className="badge-pill p-3 d-block col-7 ml-auto mr-auto"
                    style={{
                      background: PrimaryTheme.warn,
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                    }}
                  >
                    {title}
                  </span>
                </div>
                {user.isSuperAggregator ? (
                  <div style={{ width: "100%", marginTop: "20px" }}>
                    {type !== 2 && type !== 4 && (
                      <div>
                        <span
                          style={{
                            padding: "10px 35px 10px 35px",
                            borderLeft: `1px solid ${PrimaryTheme.primary}`,
                            borderTop: `1px solid ${PrimaryTheme.primary}`,
                            borderBottom: `1px solid ${PrimaryTheme.primary}`,
                            borderTopLeftRadius: "20px",
                            borderBottomLeftRadius: "20px",
                            background:
                              SingleTab === 1 ? PrimaryTheme.primary : "",
                            color: SingleTab === 1 ? "white" : "",
                            cursor: "pointer",
                          }}
                          onClick={() => handleSingleTabClicked(1)}
                        >
                          Agent
                        </span>
                        <span
                          style={{
                            padding: "10px 35px 10px 35px",
                            borderRight: `1px solid ${PrimaryTheme.primary}`,
                            borderTop: `1px solid ${PrimaryTheme.primary}`,
                            borderBottom: `1px solid ${PrimaryTheme.primary}`,
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background:
                              SingleTab === 2 ? PrimaryTheme.primary : "",
                            color: SingleTab === 2 ? "white" : "",
                            cursor: "pointer",
                          }}
                          onClick={() => handleSingleTabClicked(2)}
                        >
                          Aggregator
                        </span>
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                <p
                  className="mt-3 mb-5"
                  style={{
                    fontFamily: PrimaryTheme.fonts?.RegularFont,
                    fontSize: 14,
                    color: PrimaryTheme.light,
                  }}
                >
                  {subtitle}
                </p>

                <div className="form-group mt-4 text-left">
                  <label
                    htmlFor="terminal"
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.dark,
                    }}
                  >
                    Terminal ID
                  </label>
                  <Input
                    type="text"
                    placeholder="Terminal"
                    autoComplete="text"
                    showIcon
                    required
                    id="terminal"
                    value={terminal}
                    disabled
                    inputMode="text"
                    onChange={(e) => setTerminal(e.target.value)}
                    isInput
                    style={{
                      fontFamily: PrimaryTheme.fonts?.RubikLight,
                      color: PrimaryTheme.dark,
                      background: "#F4F7FC",
                    }}
                  />
                </div>

                {type !== 10 && type !== 3 ? (
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="agent"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      {SingleTab === 1 ? " Agent" : "Aggregator"}
                    </label>
                    <Input
                      type="text"
                      placeholder="Agent"
                      autoComplete="fullname"
                      showIcon
                      required
                      id="agent"
                      value={agent}
                      disabled
                      inputMode="text"
                      onChange={(e) => setAgent(e.target.value)}
                      isInput
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        background: "#F4F7FC",
                      }}
                    />
                  </div>
                ) : (
                  ""
                )}
                {(type === 1 || type === 6 || type === 3 || type === 10) && (
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="comment"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Comment
                    </label>
                    <Input
                      type="text"
                      placeholder="Comment"
                      autoComplete="text"
                      showIcon
                      required
                      id="comment"
                      value={comment}
                      // disabled={submitted}
                      inputMode="text"
                      onChange={(e) => setComment(e.target.value)}
                      isInput
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        background: "#F4F7FC",
                      }}
                    />
                  </div>
                )}

                {SingleTab === 2 && type === 3 && (
                  <div className="form-group text-left">
                    <label
                      htmlFor="state"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Select Aggregator
                    </label>
                    <select
                      className="custom-select"
                      value={agentId}
                      onChange={(e) => setAgentId(e.target.value)}
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        backgroundColor: "#F4F7FC",
                        borderRadius: 25,
                        border: "1px solid white",
                        padding: 15,
                        height: "auto",
                        boxShadow: "none",
                      }}
                    >
                      <option value="0">Select Aggregator</option>
                      {AggregatorList &&
                        AggregatorList.map((item: any, index: number) => (
                          <option key={index} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                  </div>
                )}

                {SingleTab === 1 && type === 3 && (
                  <div className="form-group text-left">
                    <label
                      htmlFor="state"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Select Agent
                    </label>
                    <Select
                      defaultValue={agentArrayList[0].value}
                      onChange={setAgentId}
                      options={agentArrayList}
                    />
                    {/* <select
                      className="custom-select"
                      value={agentId}
                      onChange={(e) => setAgentId(e.target.value)}
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        backgroundColor: "#F4F7FC",
                        borderRadius: 25,
                        border: "1px solid white",
                        padding: 15,
                        height: "auto",
                        boxShadow: "none",
                      }}
                    >
                      <option value="0">Select Agent</option>
                      {agentList &&
                        agentList.map((item: any, index: number) => (
                          <option key={index} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                    </select> */}
                  </div>
                )}

                <div className="row m-0 justify-content-center align-items-center">
                  <div className="col-md-12 text-left">
                    <label
                      htmlFor="agent"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      ENTER PIN
                    </label>
                  </div>
                  <OtpInput
                    value={pin}
                    onChange={(e: any) => setPin(e)}
                    numInputs={4}
                    isInputNum
                    shouldAutoFocus
                    inputStyle={{
                      width: "45px",
                      height: "45px",
                      fontSize: "24px",
                      padding: 0,
                      textAlign: "center",
                      borderRadius: 10,
                      border: "1px solid",
                      borderColor: PrimaryTheme.primary,
                    }}
                    isInputSecure
                    separator={<span className="mr-3"> </span>}
                  />
                </div>

                <div className="form-group mt-5 mb-0">
                  {type === 1 && (
                    <Input
                      onClick={handleRetrieval}
                      type="button"
                      isInput
                      value={loading ? "Retrieving..." : "Confirm Retrieval"}
                      disabled={pin.length === 0 || loading || comment === ""}
                      style={{
                        background: PrimaryTheme.primary,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.white,
                      }}
                      className="text-bold border-0 col-md-6"
                    />
                  )}

                  {(type === 2 || type === 4) && (
                    <Input
                      onClick={handleSubmit}
                      type="button"
                      isInput
                      value={loading ? "Please wait..." : "Confirm Action"}
                      disabled={pin.length === 0 || loading}
                      style={{
                        background: PrimaryTheme.primary,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.white,
                      }}
                      className="text-bold border-0 col-md-6"
                    />
                  )}

                  {type === 3 && (
                    <Input
                      onClick={handleMapping}
                      type="button"
                      isInput
                      value={loading ? "Mapping..." : "Confirm Mapping"}
                      disabled={pin.length === 0 || loading}
                      style={{
                        background: PrimaryTheme.primary,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.white,
                      }}
                      className="text-bold border-0 col-md-6"
                    />
                  )}

                  {type === 10 && (
                    <Input
                      onClick={handleMappingSuperAggregator}
                      type="button"
                      isInput
                      value={loading ? "Mapping..." : "Confirm Mapping"}
                      disabled={pin.length === 0 || loading}
                      style={{
                        background: PrimaryTheme.primary,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.white,
                      }}
                      className="text-bold border-0 col-md-6"
                    />
                  )}

                  {type === 6 && (
                    <Input
                      onClick={(e: any) => handlePND(e)}
                      type="button"
                      isInput
                      value={loading ? "Please wait..." : "Confirm PND"}
                      disabled={pin.length === 0 || loading}
                      style={{
                        background: PrimaryTheme.primary,
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.white,
                      }}
                      className="text-bold border-0 col-md-6"
                    />
                  )}
                  {/* <button className="btn btn-light" onClick={closeModal}>Clear</button> */}
                </div>
              </div>
            )}
          </div>
        </AlertModal>

        <StatusAlert
          subtitle={subtitle}
          title={title}
          buttonTitle="Goto POS"
          backTitle="Back to dashboard"
          goBack={goBack}
          onClick={handleRefresh}
        ></StatusAlert>
      </div>
    </React.Fragment>
  );
}
